import Keycloak from "keycloak-js";

function initWithNewLogin(resolve, reject) {
    window.keycloak.init({onLoad: 'login-required'})
        .success(authenticated => {
            if (authenticated) {
                updateSessionStorage();
                resolve();
            }
            else {
                reject();
            }
        })
        .error(error => {
            reject(error);
        })
}

function updateSessionStorage() {
    sessionStorage.setItem("oidc", JSON.stringify({
        token: window.keycloak.token,
        refreshToken: window.keycloak.refreshToken,
        idToken: window.keycloak.idToken
    }));
}

export default function() {
    return new Promise((resolve, reject) => {
        try{
            window.keycloak = Keycloak({
                url: process.env.REACT_APP_OIDC_AUTH_URL || '/hotdeals/auth',
                realm: 'me',
                clientId: 'portal'
            });

            let oidc = sessionStorage.getItem('oidc');
            if (oidc) {
                oidc = JSON.parse(oidc);
                window.keycloak.init({
                    token: oidc.token,
                    refreshToken: oidc.refreshToken,
                    idToken: oidc.idToken
                }).success(authenticated => {
                    if (!authenticated) {
                        initWithNewLogin(resolve, reject);
                    }
                    else {
                        window.keycloak.updateToken(3 + 5)
                            .success(() => resolve())
                            .error(error => initWithNewLogin(resolve, reject));
                        updateSessionStorage();
                    }
                }).error(error => { reject(error) })
            } else {
                initWithNewLogin(resolve, reject);
            }
        }catch(e){
            reject(e);
        }
    });
};
